export const removeDuplicates = (data: any[]) => {
    return data.filter((value, index, self) => index === self.findIndex((t) => t.id === value.id));
}